import { useEffect } from "react";
export const useDocumentTitle = (title: string) => {

    useEffect(() => {
        //document.title = `${title} - RentalWorks`;
        document.title = title;
    }, [title]);

    return null;
}